import { IconProps } from './types'

export const Gifted = ({ className }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 87 85'
      height='85'
      width='87'
      className={className}
    >
      <g clip-path='url(#clip0_541_1519)'>
        <path
          fill='currentColor'
          d='M57.389 71.015H37.249C37.249 69.36 38.594 68.015 40.249 68.015H57.389C58.004 68.015 58.504 67.565 58.504 67.01C58.504 63.435 55.434 60.52 51.659 60.52H33.534C32.049 60.52 30.604 60.225 29.249 59.645L25.599 58.085C22.464 56.75 18.954 56.6 15.704 57.675L3.78902 61.61C2.21402 62.13 0.519023 61.275 -0.000976562 59.7L14.759 54.82C18.699 53.52 22.964 53.695 26.774 55.325L30.424 56.885C31.409 57.305 32.454 57.52 33.534 57.52H51.659C57.089 57.52 61.504 61.775 61.504 67.01C61.504 69.22 59.659 71.015 57.389 71.015Z'
        />
        <path
          fill='currentColor'
          d='M39.104 84.7352C38.524 84.7352 37.954 84.6702 37.404 84.5452C37.024 84.4552 36.649 84.3452 36.254 84.2052L19.419 78.1802C18.399 77.7702 17.264 77.8402 16.299 78.3752L16.079 78.4752L4.00903 82.8202C3.44903 81.2602 4.25403 79.5402 5.81403 78.9802L14.954 75.6902C16.679 74.7752 18.694 74.6652 20.509 75.3852L37.259 81.3802C37.544 81.4802 37.809 81.5602 38.074 81.6202C38.859 81.8052 39.744 81.7652 40.629 81.5102C45.039 80.2452 57.379 75.9352 58.354 75.4202L82.554 62.6452C81.874 61.7402 80.744 60.5702 79.184 60.0252C77.594 59.4702 75.799 59.6702 73.854 60.6152L65.239 64.8402C64.509 63.3502 65.124 61.5552 66.614 60.8252L72.539 57.9202C75.244 56.6002 77.824 56.3652 80.204 57.2002C84.119 58.5802 85.964 62.4102 86.039 62.5752L86.649 63.8702L59.779 78.0552C58.504 78.7652 45.354 83.2702 41.459 84.3852C40.674 84.6102 39.874 84.7252 39.099 84.7252'
        />
        <path
          fill='currentColor'
          d='M50.9736 46.4099C49.3186 46.4099 47.9736 45.0649 47.9736 43.4099V12.1299C49.6286 12.1299 50.9736 13.4749 50.9736 15.1299V46.4099Z'
        />
        <path
          fill='currentColor'
          d='M48.4392 29.045L40.5342 21.445C41.6842 20.25 43.5792 20.215 44.7742 21.36L50.5142 26.88L48.4342 29.04L48.4392 29.045Z'
        />
        <path
          fill='currentColor'
          d='M50.5195 32.61L48.4395 30.45L54.7195 24.4C55.9145 23.25 57.8145 23.285 58.9595 24.48L50.5195 32.615V32.61Z'
        />
        <path
          fill='currentColor'
          d='M44.6586 40.825H43.9636C35.6486 40.825 28.6836 34.02 28.8536 25.705C28.9486 21.085 31.1986 17.495 35.7186 14.76C35.8536 6.87 42.2236 0 49.4736 0C57.1286 0 63.3586 6.23 63.3586 13.88C63.3586 14.175 63.3486 14.47 63.3236 14.78C67.9836 17.21 70.8336 21.9 70.8336 27.275C70.8336 34.98 64.7086 40.79 56.5886 40.79H53.7136V40.665C53.7136 39.08 54.9986 37.79 56.5886 37.79C62.9986 37.79 67.8336 33.27 67.8336 27.275C67.8336 22.74 65.2636 18.82 61.1236 17.055L60.0586 16.6L60.2286 15.455C60.3186 14.85 60.3586 14.35 60.3586 13.875C60.3586 7.975 55.3736 2.995 49.4736 2.995C43.5736 2.995 38.7186 9.34 38.7186 15.01C38.7186 15.11 38.7236 15.205 38.7336 15.3L38.7936 16.47L37.9736 16.92C33.7386 19.255 31.8536 22.055 31.8536 26.01C31.8536 31.62 35.7836 36.325 41.0386 37.525C42.7386 37.915 44.1136 39.165 44.6636 40.82'
        />
        <path
          fill='currentColor'
          d='M76.5539 52.685C75.2989 53.53 73.6739 53.435 72.4539 52.545C71.2739 51.69 69.8389 51.21 68.3339 51.21H27.5939C27.2139 51.21 26.8439 51.26 26.4889 51.355C25.0639 51.735 23.5489 51.42 22.5089 50.38L22.4639 50.335C23.8339 48.965 25.6589 48.21 27.5989 48.21H68.3389C71.6739 48.21 74.7789 49.86 76.6439 52.625L76.5589 52.68L76.5539 52.685Z'
        />
      </g>
      <defs>
        <clipPath id='clip0_541_1519'>
          <rect fill='white' height='84.735' width='86.655' />
        </clipPath>
      </defs>
    </svg>
  )
}
